// extracted by mini-css-extract-plugin
export default {"component__container":"rainTable_component__container__6qhJU","inner__container":"rainTable_inner__container__VACH3","section__header":"rainTable_section__header__wl3md"};